module.exports = __webpack_public_path__ + "img/blank-comic-book_B098H61T18.3228d3d6.jpg";